import { StyleSheet } from 'aphrodite';
import COLORS from '../../library/colors';

const styles = StyleSheet.create({
  root: {
  },
  logo: {
    position: 'fixed',
    height: 24,
    left: 32,
    top: 32
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/welcome/welcome-styles.js